// AUTO-GENERATED by Garden Studio — positie + grootte per thema:niveau.
import type { ThemeGardenSlot } from "./results-garden";

export const GARDEN_TIER_SIZES: Record<string, Partial<ThemeGardenSlot>> = {
  "acceptatie:1": { left: 18, bottom: 22, zIndex: 8, maxHeightPercent: 29 },
  "defusie:1": { left: 36, bottom: 13, zIndex: 2, maxHeightPercent: 20 },
  "hierEnNu:1": { left: 75, bottom: 2, zIndex: 7, maxHeightPercent: 38 },
  "waardengerichtHandelen:1": { left: 49, bottom: 2, zIndex: 0, maxHeightPercent: 44 },
  "acceptatie:2": { left: 16, bottom: 1, zIndex: 8, maxHeightPercent: 44 },
  "defusie:2": { left: 40, bottom: 19, zIndex: 2, maxHeightPercent: 18 },
  "zelfAlsContext:1": { left: 77, bottom: 29, zIndex: 3, maxHeightPercent: 49 },
  "zelfAlsContext:2": { left: 79, bottom: 23, zIndex: 3, maxHeightPercent: 49 },
  "hierEnNu:2": { left: 75, bottom: 1, zIndex: 7, maxHeightPercent: 46 },
  "waarden:1": { left: 28, bottom: 32, zIndex: 2, maxHeightPercent: 60 },
  "waarden:2": { left: 30, bottom: 22, zIndex: 2, maxHeightPercent: 72 },
  "waardengerichtHandelen:2": { left: 49, bottom: 0, zIndex: 0, maxHeightPercent: 43 },
  "acceptatie:3": { left: 16, bottom: 0, zIndex: 8, maxHeightPercent: 44 },
  "defusie:3": { left: 35, bottom: 6, zIndex: 2, maxHeightPercent: 50 },
  "zelfAlsContext:3": { left: 79, bottom: 21, zIndex: 3, maxHeightPercent: 49 },
  "hierEnNu:3": { left: 73, bottom: 0, zIndex: 7, maxHeightPercent: 46 },
  "waarden:3": { left: 30, bottom: 19, zIndex: 2, maxHeightPercent: 85 },
  "waardengerichtHandelen:3": { left: 49, bottom: 0, zIndex: 0, maxHeightPercent: 47 },
};
